const e={gwei:9,wei:18},i={ether:-9,wei:9},t={ether:-18,gwei:-9};export{e as etherUnits,i as gweiUnits,t as weiUnits};
